/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1SerieId200,
  GetApiV1SerieId401,
  GetApiV1SerieId404,
  GetApiV1SerieId500,
  GetApiV1SerieIdPathParams,
  GetApiV1SerieIdQueryResponse,
} from "../../types/serieRegistroController/GetApiV1SerieId.ts";
import { serieViewModelSchema } from "../serieViewModelSchema.ts";

export const getApiV1SerieIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1SerieIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1SerieId200Schema = z.lazy(
  () => serieViewModelSchema,
) as unknown as ToZod<GetApiV1SerieId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1SerieId401Schema =
  z.any() as unknown as ToZod<GetApiV1SerieId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1SerieId404Schema =
  z.any() as unknown as ToZod<GetApiV1SerieId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1SerieId500Schema =
  z.any() as unknown as ToZod<GetApiV1SerieId500>;

export const getApiV1SerieIdQueryResponseSchema = z.lazy(
  () => getApiV1SerieId200Schema,
) as unknown as ToZod<GetApiV1SerieIdQueryResponse>;
